import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import * as XLSX from 'xlsx';

const Header = () => {
  const { signOut } = useAuth();
  const { currentProject, saveInventoryData } = useData();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsProcessing(true);
    try {
      let extractedDate = null;
      const dateMatch = file.name.match(/(\d{8})/); 
      if (dateMatch) {
        const rawDate = dateMatch[1];
        extractedDate = `${rawDate.substring(6, 8)}/${rawDate.substring(4, 6)}/${rawDate.substring(0, 4)}`;
      }

      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_json(worksheet);

      const importMeta = {
        filename: file.name,
        extracted_date: extractedDate,
        upload_timestamp: new Date().toISOString()
      };

      await saveInventoryData(rawData, importMeta);
      alert(`✅ Datos actualizados.\nFecha: ${extractedDate || 'Desconocida'}`);
      e.target.value = ''; 

    } catch (error) {
      console.error(error);
      alert('Error: ' + error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <header className="bg-white shadow-sm px-4 py-1 h-16 flex justify-between items-center sticky top-0 z-40 border-b-2 border-red-600">
      <div className="flex items-center gap-3">
        <img 
          src="https://assets.brandbay.io/brands/1736547941865x394131539339247600/assets/OX3X76ITURRI_YourSafetyMatters.jpg" 
          alt="ITURRI" 
          className="h-12 w-auto object-contain"
        />
        <div className="flex flex-col justify-center">
          {/* TÍTULO NORMALIZADO */}
          <h1 className="font-medium text-slate-800 leading-none text-xl tracking-tight">
            mini<span className="text-red-600 font-bold">GIV</span>
          </h1>
          <div className="flex flex-col">
            {/* NOMBRE PROYECTO MÁS GRANDE */}
            <span className="text-sm text-slate-600 font-bold uppercase truncate max-w-[200px] leading-tight mt-0.5">
              {currentProject?.name || '...'}
            </span>
            {currentProject?.last_import_info?.extracted_date && (
               <span className="text-[9px] font-medium text-red-600 bg-red-50 px-1.5 rounded w-fit mt-0.5">
                 📅 {currentProject.last_import_info.extracted_date}
               </span>
            )}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <label className={`
            flex items-center justify-center w-9 h-9 rounded-lg 
            ${isProcessing ? 'bg-gray-100' : 'bg-red-50 text-red-600 hover:bg-red-100'}
            cursor-pointer transition-all active:scale-95 border border-red-100
          `} title="Actualizar Base de Datos">
            <input 
              type="file" 
              accept=".xlsx, .xls" 
              className="hidden" 
              onChange={handleFileUpload}
              disabled={isProcessing}
            />
            {isProcessing ? (
              <span className="animate-spin text-sm">⏳</span>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
                <path d="M3 5v14c0 1.66 4 3 9 3s 9-1.34 9-3V5"></path>
              </svg>
            )}
        </label>

        <button 
          onClick={signOut}
          className="w-9 h-9 flex items-center justify-center bg-red-50 text-red-600 hover:bg-red-100 rounded-lg transition-all active:scale-95 border border-red-100"
          title="Cerrar Sesión"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;